import axios from "axios";
import { APIs } from "../api/api";

const userData = JSON.parse(localStorage.getItem("_2mseamlessTailoring"));
let user = userData?.user;
let token = userData?.token;
let email =userData?.user?.email



const headers = {
  email: user?.email ?? "",
  authorization: token ?? "",
};

export const signup = (data) => {
  return axios.post(APIs.AUTH.SIGNUP, { ...data }).then((res) => {
    return res;
  });
};

export const signin = (data) => {
  return axios.post(APIs.AUTH.SIGNIN, { ...data }).then((res) => res);
};

export const updateProfile = (payload) => {
  console.log(payload);
  return axios.put(`${APIs.AUTH.EDIT_PROFILE}`, payload, {
    headers: {
      authorization: token,
      email,
      // 'Content-Type': 'multipart/form-data'
    }
   
  })
}

export const notifications = () => {
  return axios.get(`${APIs.AUTH.NOTIFICATION}`, {
    headers: {...headers}
  })
}